"use strict";
/**
 * Thin wrapper around the AI Hub `/elements`, `/element-groups` and
 * `/element-reviews` HTTP endpoints. Mirrors the backend contract
 * defined in `backend/src/api/routes/elements.ts` and
 * `backend/src/api/routes/element-reviews.ts`.
 *
 * Keeping this in `shared/services` lets multiple admin views
 * (Metrics today, Personas / Pain&Benefits later) share one transport
 * layer instead of each owning a copy of the fetch logic.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.editReview = exports.rejectReview = exports.approveReview = exports.fetchPendingReviews = exports.applyElementGroupSuggestion = exports.suggestElementGroups = exports.setElementGroup = exports.deleteElementGroup = exports.updateElementGroup = exports.createElementGroup = exports.fetchElementGroupsForType = exports.fetchAllElementsForType = void 0;
var config_1 = require("../../config");
var buildQuery = function (params) {
    var parts = [];
    for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = params[key];
        if (value === undefined || value === null || value === '') {
            continue;
        }
        parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(String(value)));
    }
    return parts.length > 0 ? "?" + parts.join('&') : '';
};
/**
 * Fetch every element of a given type by paging until the server
 * stops returning more rows. Used by the admin Metrics view, where
 * total volume per type is small (hundreds, not millions).
 */
exports.fetchAllElementsForType = function (type, opts) { return __awaiter(void 0, void 0, void 0, function () {
    var apiGet, pageSize, page, includeInactive, all, maxPages, result;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiGet = config_1.getApiGet();
                pageSize = 200;
                page = 1;
                includeInactive = (_a = opts === null || opts === void 0 ? void 0 : opts.includeInactive) !== null && _a !== void 0 ? _a : false;
                all = [];
                maxPages = 50;
                _b.label = 1;
            case 1:
                if (!(page <= maxPages)) return [3 /*break*/, 3];
                return [4 /*yield*/, apiGet("/ai/elements" + buildQuery({ type: type, page: page, pageSize: pageSize, includeInactive: includeInactive }))];
            case 2:
                result = (_b.sent());
                all.push.apply(all, result.items);
                if (result.items.length < pageSize || all.length >= result.total) {
                    return [3 /*break*/, 3];
                }
                page += 1;
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/, all];
        }
    });
}); };
exports.fetchElementGroupsForType = function (type) { return __awaiter(void 0, void 0, void 0, function () {
    var apiGet;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiGet = config_1.getApiGet();
                return [4 /*yield*/, apiGet("/ai/element-groups" + buildQuery({ type: type }))];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
exports.createElementGroup = function (input) { return __awaiter(void 0, void 0, void 0, function () {
    var apiPost;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiPost = config_1.getApiPost();
                return [4 /*yield*/, apiPost('/ai/element-groups', input)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
exports.updateElementGroup = function (id, patch) { return __awaiter(void 0, void 0, void 0, function () {
    var apiPatch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiPatch = config_1.getApiPatch();
                return [4 /*yield*/, apiPatch("/ai/element-groups/" + id, patch)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
exports.deleteElementGroup = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var apiDelete;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiDelete = config_1.getApiDelete();
                return [4 /*yield*/, apiDelete("/ai/element-groups/" + id)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.setElementGroup = function (elementId, groupId) { return __awaiter(void 0, void 0, void 0, function () {
    var apiPost;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiPost = config_1.getApiPost();
                return [4 /*yield*/, apiPost("/ai/elements/" + encodeURIComponent(elementId) + "/group", { groupId: groupId })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.suggestElementGroups = function (type, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var apiPost;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiPost = config_1.getApiPost();
                    return [4 /*yield*/, apiPost('/ai/element-groups/suggest', __assign(__assign({ type: type }, (typeof options.clusterThreshold === 'number'
                            ? { clusterThreshold: options.clusterThreshold }
                            : {})), (typeof options.minClusterSize === 'number'
                            ? { minClusterSize: options.minClusterSize }
                            : {})))];
                case 1: return [2 /*return*/, (_a.sent())];
            }
        });
    });
};
exports.applyElementGroupSuggestion = function (input) { return __awaiter(void 0, void 0, void 0, function () {
    var apiPost;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiPost = config_1.getApiPost();
                return [4 /*yield*/, apiPost('/ai/element-groups/suggest/apply', input)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
exports.fetchPendingReviews = function (type, limit) {
    if (limit === void 0) { limit = 50; }
    return __awaiter(void 0, void 0, void 0, function () {
        var apiGet, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiGet = config_1.getApiGet();
                    return [4 /*yield*/, apiGet("/ai/element-reviews" + buildQuery({ type: type, limit: limit }))];
                case 1:
                    result = (_a.sent());
                    return [2 /*return*/, result.items || []];
            }
        });
    });
};
exports.approveReview = function (id, notes) { return __awaiter(void 0, void 0, void 0, function () {
    var apiPost;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiPost = config_1.getApiPost();
                return [4 /*yield*/, apiPost("/ai/element-reviews/" + id + "/approve", notes ? { notes: notes } : {})];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.rejectReview = function (id, notes) { return __awaiter(void 0, void 0, void 0, function () {
    var apiPost;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiPost = config_1.getApiPost();
                return [4 /*yield*/, apiPost("/ai/element-reviews/" + id + "/reject", notes ? { notes: notes } : {})];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.editReview = function (id, body) { return __awaiter(void 0, void 0, void 0, function () {
    var apiPost;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiPost = config_1.getApiPost();
                return [4 /*yield*/, apiPost("/ai/element-reviews/" + id + "/edit", body)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
